import * as React from "react";
import {Icon} from "../../atoms/Icon/Icon";
import InputWithIcon from "../../atoms/Input/InputWithIcon";
import TimePickerList from "../TimePickerList/TimePickerList";
import DateUtils from "../../../../utils/DateUtils";
import "./timePicker.scss";
import moment = require("moment");

interface IProps {
	/**
	 * Initial moment datetime.
	 */
	initialDateTime: moment.Moment;
	/**
	 * On time change callback.
	 * @param {moment.Moment} moment
	 */
	onTimeChange: (moment: moment.Moment) => void;
	/**
	 * Time picker input placeholder.
	 */
	placeholder?: string;
	/**
	 * Indicates if time picker should be disabled.
	 */
	disabled?: boolean;
	/**
	 * Disabled date times
	 */
	disabledDateTimes?: moment.Moment[];
	/**
	 * Start time in 'HH:mm' format.
	 */
	startTime?: string;
	/**
	 * End time in 'HH:mm' format.
	 */
	endTime?: string;
}

interface IState {
	/**
	 * Indicates if dropdown is visible.
	 */
	dropDownVisible: boolean;
}

export default class TimePicker extends React.Component<IProps, IState> {
	public static defaultProps: Partial<IProps> = {
		startTime: "6:00",
		endTime: "22:00"
	};

	constructor(props: IProps) {
		super(props);
		this.state = {
			dropDownVisible: false
		};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.onOutsideClick = this.onOutsideClick.bind(this);
		this.onTimeSelect = this.onTimeSelect.bind(this);
	}

	render() {
		return (
			<div className={"m-time-picker-input"}>
				<InputWithIcon type={"text"}
							   value={this.props.initialDateTime ? this.props.initialDateTime.format(DateUtils.TIME_FORMAT) : ""}
							   placeholder={this.props.placeholder}
							   appendIcon={Icon.Reminder}
							   disabled={this.props.disabled}
							   onClick={this.toggleDropdown}/>
				{this.state.dropDownVisible &&
				<TimePickerList initialDate={this.props.initialDateTime}
								onTimeSelect={this.onTimeSelect}
								onOutsideClick={this.onOutsideClick}
								startTime={this.props.startTime}
								endTime={this.props.endTime}
								interval={15}
								disabledDateTimes={this.props.disabledDateTimes}/>}
			</div>
		);
	}

	/**
	 * Toggle picker dropdown.
	 */
	toggleDropdown() {
		if (!this.props.disabled) {
			this.setState({dropDownVisible: !this.state.dropDownVisible});
		}
	}

	/**
	 * On time select callback.
	 * @param {moment.Moment} time
	 */
	onTimeSelect(time: moment.Moment) {
		this.props.onTimeChange(time);
		this.setState({dropDownVisible: false});
	}

	/**
	 * On outside click.
	 */
	onOutsideClick() {
		this.setState({dropDownVisible: false});
	}
}
